import React, { useEffect, useState } from "react";
import { PayPalButtons, PayPalScriptProvider } from "@paypal/react-paypal-js";

const PayPal = (props) => {
  const [price, setPrice] = useState(props.price);

  useEffect(() => {
    setPrice(props.price);
  }, [props.price]);

  // TODO: Add on error logic
  return (
    <PayPalScriptProvider
      options={{
        "client-id": props.liveClientId,
      }}
    >
      <PayPalButtons
        createOrder={(data, actions) => {
          return actions.order.create({
            purchase_units: [
              {
                amount: {
                  value: price,
                },
              },
            ],
          });
        }}
        onApprove={(data, actions) => {
          return actions.order
            .capture()
            .then((captureResponse) => {
              const captureId =
                captureResponse.purchase_units[0].payments.captures[0].id;
              props.handleClick(data.orderID, captureId, "PayPal");
            })
            .catch((err) => {
              console.error("Payment capture error:", err);
              props.setMessage(
                "Payment could not be completed. Please try again or contact support.",
              );
              props.setSeverity("error");
              props.setOpen(true);
            });
        }}
        onError={(err) => {
          console.error("PayPal error:", err);
          props.setMessage(
            "Payment processing is temporarily unavailable. Please try again later or contact us to complete your registration.",
          );
          props.setSeverity("error");
          props.setOpen(true);
        }}
      />
    </PayPalScriptProvider>
  );
};
export default PayPal;
